/**
 * TYT Platform API
 * This is the TYT Platform API. It is used by TYT's apps to interact 
 * with the underlying platform. 
 *
 * NOTE: This file is auto generated. 
 * Do not edit this file manually.
 */

import { BaseModel, Expand, Model, Type } from '../../common';


export interface UserOmniauthRequest {

    uuid?: string;

    /**
     * Authentication provider
     */
    provider?: string;

    uid?: string;

    /**
     * Provider supplied email address
     */
    email?: string;

    email_verified?: string;

    name?: string;

    revocable?: string;

    nickname?: string;

    entitled_sku?: string;

}

@Model('UserOmniauth')
export class ApiUserOmniauth extends BaseModel implements UserOmniauthRequest {

    
    
    uuid: string;

    /**
     * Authentication provider
     */
    
    
    provider: string;

    
    
    uid: string;

    /**
     * Provider supplied email address
     */
    
    
    email: string;

    
    
    email_verified: string;

    
    
    name: string;

    
    
    revocable: string;

    
    
    nickname: string;

    
    
    entitled_sku: string;

}
